import { lazy } from 'react';

const RipplingPromotionDialog = lazy(() => import('./RipplingPromotionDialog'));
const RipplingPostConversionDialog = lazy(() => import('./RipplingPostConversionDialog'));
const RipplingPhoneCollectionDialog = lazy(() => import('./RipplingPhoneCollectionDialog'));

// Identifiers for each dialog
export const RIPPLING_PROMOTION_DIALOG = 'RIPPLING_PROMOTION_DIALOG';
export const RIPPLING_POST_CONVERSION_DIALOG = 'RIPPLING_POST_CONVERSION_DIALOG';
export const RIPPLING_PHONE_COLLECTION_DIALOG = 'RIPPLING_PHONE_COLLECTION_DIALOG';

const ripplingDialogs = {
  [RIPPLING_PROMOTION_DIALOG]: RipplingPromotionDialog,
  [RIPPLING_POST_CONVERSION_DIALOG]: RipplingPostConversionDialog,
  [RIPPLING_PHONE_COLLECTION_DIALOG]: RipplingPhoneCollectionDialog,
};

export default ripplingDialogs;
